import { call, put, takeLatest } from "redux-saga/effects";

import { getViewAttendanceData, insertMissingAttendance } from "../http/requests/view-attendance";
import {
  setVtrackLoader
} from "../redux/actions";

import { ViewAttendanceType, setViewAttendanceData, setAttendanceCorrectionSuccess, setAttendanceCorrectionError, setMissingAttendanceSuccess, setMissingAttendanceError } from "../redux/actions/view-attendance";

function* workerViewAttendanceSaga({ payload }) {
    try {
      yield put(setVtrackLoader(true));
      const viewAttendanceDetails = yield call(
        getViewAttendanceData,
        payload.month,
        payload.year,
        payload.employeeId
      );
        yield put(setViewAttendanceData(viewAttendanceDetails));
        yield put(setVtrackLoader(false));
    } catch (err) {
      console.log(err);
      yield put(setVtrackLoader(false));
    }
  };
  
  export function* viewAttendanceSaga() {
    yield takeLatest(
      ViewAttendanceType.GET_VIEW_ATTENDANCE_DATA,
      workerViewAttendanceSaga
    );
    yield takeLatest(
      ViewAttendanceType.SUBMIT_ATTENDANCE_CORRECTION,
      workerRegularizeAttendanceSaga
    );
    yield takeLatest(
      ViewAttendanceType.INSERT_MISSING_ATTENDANCE,
      workerInsertMissingAttendanceSaga
    );
  };

function* workerRegularizeAttendanceSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const response = yield call(insertMissingAttendance, payload);
    yield put(setAttendanceCorrectionSuccess(response));
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setAttendanceCorrectionError(err));
    yield put(setVtrackLoader(false));
  }
};

function* workerInsertMissingAttendanceSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const response = yield call(insertMissingAttendance, payload);
    yield put(setMissingAttendanceSuccess(response));
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setMissingAttendanceError(err));
    yield put(setVtrackLoader(false));
  }
};